/* Mobile layout fix, loaded last so it wins.

   Measured on a real 390px viewport before fixing:
     .lp .wrap        width 390, padding 22px 44px 46px  -> content box 302px
     grid-template-columns computed to **434px**
     .gallery / .main / .details / .thumbs  all 434px wide at left: 44
     43 elements overflowing the viewport

   Cause: `1fr` is shorthand for `minmax(auto, 1fr)`, and the `auto` minimum refuses to
   go below the widest child's min-content width. The product image is 408px min-content,
   so the single column inflated to 434px and pushed every row out of the screen. It was
   invisible as a scrollbar only because of the `overflow-x:hidden` safety net, which
   meant the page was silently clipping content rather than fitting it.

   Fix: minmax(0,1fr) lets the track shrink, min-width:0 on the children lets them
   shrink with it, and the desktop 44px side padding comes down to 18px. */
(function(){
var s=document.createElement('style');
s.textContent=
'@media(max-width:900px){'+
'  .lp .wrap{grid-template-columns:minmax(0,1fr)!important;padding-left:18px!important;padding-right:18px!important;}'+
'  .lp .wrap>*{min-width:0!important;max-width:100%!important;}'+
'  .lp .wrap .gallery,.lp .wrap .main,.lp .wrap .details,.lp .wrap .thumbs{width:100%!important;max-width:100%!important;min-width:0!important;}'+
'  .lp .wrap .main img,.lp .wrap .mimg{max-width:100%!important;}'+
'  .lp .wrap .thumbs{max-height:none!important;overflow-x:auto!important;overflow-y:hidden!important;}'+
'  .lp .band .inr,.lpair .lpin,.lrev .lrin{max-width:100%!important;}'+
'  .lp .details{padding-left:0!important;padding-right:0!important;}'+
'}'+
'@media(max-width:600px){'+
'  .lp .wrap{padding-left:16px!important;padding-right:16px!important;}'+
'  .lp section.band{padding-left:16px!important;padding-right:16px!important;}'+
'}';
document.head.appendChild(s);
})();